interface SVGProps {
    size?: number;
}



export const Minus = ({ size }: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size ? size : '10'} height="2" viewBox={`0 0 ${size ? size : '10'} 2`} fill="none">
            <line x1="0%" x2="100%" y1="50%" y2="50%" strokeWidth="2" stroke="#838280" />
        </svg>
    )
}